/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1452
 */

var r = require(/* 1181 */"../../../../../253/2568/2569/2570/1459/1181/index")
var i = require(/* 863 */"../../../../../253/2568/2569/2570/1459/863")
var /* [auto-meaningful-name] */Object$prototype$hasOwnProperty = Object.prototype.hasOwnProperty
module.exports = function (e, t, n) {
  var a = e[t]
  if (!(Object$prototype$hasOwnProperty.call(e, t) && i(a, n) && (undefined !== n || t in e))) {
    r(e, t, n)
  }
}
